/* eslint-disable no-param-reassign */
import { App } from 'vue';
import { useGeneralStore } from '@/store/generalStore';

export default {
  install: (app: App) => {
    app.config.globalProperties.$localize = (key: string) => {
      if (useGeneralStore().dataLoading) return '\u00A0';
      if (key === '') return key;
      return useGeneralStore().getMessages.get(key) || key;
    };
    app.config.globalProperties.$localizeIfPresent = (key: string) => {
      if (key === '') return key;
      return useGeneralStore().getMessages.get(key) || '';
    };
    app.config.globalProperties.$localizeError = (errorKey: string) => {
      if (errorKey === '') return errorKey;
      return useGeneralStore().getMessages.get(`error.${errorKey}`) || errorKey;
    };

    app.provide('$localize', app.config.globalProperties.$localize);
    app.provide('$localizeIfPresent', app.config.globalProperties.$localizeIfPresent);
  },
};
